<template>
  <div>
    <a-form-item label="Filter by country name:">
      <a-input-search
        placeholder="Type a country name"
        enter-button
        v-model="countryName"
        @search="searchCountries"
      />
    </a-form-item>

    <a-spin :spinning="spinning">
      <div class="spin-content">
        <a-skeleton :active="spinning" :loading="spinning" />
        <template v-if="countries">
          <CountriesCard
            v-if="filteredCountries"
            :countries="filteredCountries"
          ></CountriesCard>
        </template>
      </div>
    </a-spin>
  </div>
</template>

<script>
import CountriesCard from '@/components/countries/CountriesCard.vue';
import axios from 'axios';

export default {
  components: { CountriesCard },
  data() {
    return {
      countryName: '',
      countries: null,
      spinning: true,
    };
  },
  computed: {
    filteredCountries: {
      get() {
        const filter = new RegExp(this.countryName, 'i');
        return this.countries.filter((country) =>
          country.name.common.match(filter)
        );
      },
    },
  },
  methods: {
    getCountries() {
      const serverAPI = 'http://countries-finder-api.webtraining.fun';
      const url = `${serverAPI}/countries`;
      const serviceURL = `${url}`;
      axios.get(serviceURL).then((response) => {
        this.countries = response.data;
        this.spinning = false;
      });
    },
    searchCountries(value) {
      console.log(value);
    },
  },
  created() {
    this.getCountries();
  },
};
</script>

<style lang="scss" scoped>
.spin-content {
  // border: 1px solid #91d5ff;
  // background-color: #e6f7ff;
  padding: 30px;
}
</style>
